import { render, staticRenderFns } from "./TenderWebsite.vue?vue&type=template&id=71f9b444&scoped=true"
import script from "./TenderWebsite.vue?vue&type=script&lang=js"
export * from "./TenderWebsite.vue?vue&type=script&lang=js"
import style0 from "./TenderWebsite.vue?vue&type=style&index=0&id=71f9b444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9b444",
  null
  
)

export default component.exports